// action - snackbar
const SNACKBAR_OPEN = '@snackbar/SNACKBAR_OPEN';
export default SNACKBAR_OPEN;
